import { render, staticRenderFns } from "./Screenings.vue?vue&type=template&id=625b6ba2&scoped=true&"
import script from "./Screenings.vue?vue&type=script&lang=js&"
export * from "./Screenings.vue?vue&type=script&lang=js&"
import style0 from "./Screenings.vue?vue&type=style&index=0&id=625b6ba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625b6ba2",
  null
  
)

export default component.exports